<ng-container [formGroup]="form">
    <div [formGroupName]="question.groupName" [ngClass]="question.styles">
        @for (questionPart of question.questions; track trackByKey($index, questionPart); let isLast = $last; let isFirst = $first) {
            @if (questionPart.paragraph) {
                <span class="me-2" [class.ms-1]="!isFirst"> {{ questionPart.paragraph | translate }}</span>
            }
            <mat-form-field
                [hideRequiredMarker]="true"
                [floatLabel]="questionPart.floatingLabel"
                class="ca-form-field"
                appearance="outline"
                subscriptSizing="dynamic"
                [class.with-label]="questionPart.label"
                [ngClass]="questionPart.styles"
            >
                @if (questionPart.label) {
                    <mat-label [attr.for]="questionPart.key">{{ questionPart.label | translate }}</mat-label>
                }
                <input
                    [formControlName]="questionPart.key"
                    [placeholder]="questionPart.placeholder | translate"
                    [id]="questionPart.key"
                    [attr.data-testid]="questionPart.key"
                    [type]="questionPart.type"
                    [mask]="questionPart.mask.pattern"
                    [patterns]="$any(questionPart).mask?.customPatterns"
                    [decimalMarker]="$any(questionPart).mask?.decimalMarker"
                    [separatorLimit]="$any(questionPart).mask?.separatorLimit"
                    [dropSpecialCharacters]="
                        ($any(questionPart).mask?.dropSpecialCharacters | isNil) ? true : $any(questionPart).mask?.dropSpecialCharacters
                    "
                    [suffix]="questionPart.suffix ? ' ' + (questionPart.suffix | translate) : ''"
                    matInput
                />
                @if (questionPart.permanentHint) {
                    <mat-hint>{{ questionPart.permanentHint | translate }}</mat-hint>
                }
                @if (isInvalid(questionPart)) {
                    <mat-error>
                        <ca-form-error-message>{{ errorMessage(questionPart) | translate }}</ca-form-error-message>
                    </mat-error>
                }
            </mat-form-field>
            @if (questionPart.paragraph && isLast) {
                <span class="ms-1">.</span>
            }
        }
    </div>
</ng-container>
